import { render } from "./VoiceoverSection.vue?vue&type=template&id=4060e116"
import script from "./VoiceoverSection.vue?vue&type=script&lang=js"
export * from "./VoiceoverSection.vue?vue&type=script&lang=js"

import "./VoiceoverSection.vue?vue&type=style&index=0&id=4060e116&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__